import React from 'react'
import { Container, } from "reactstrap";
import { Row, Col, Modal } from "react-bootstrap";
import { TextField, FlatButton, RaisedButton } from "material-ui";
import "../App.css";
import { storageRef } from "../firebase";
import $ from "jquery";
import { connect } from "react-redux";
import { fetchProjects } from "../Actions/projects";
import Lightbox from "react-image-lightbox";

class AProjects extends React.Component {
    constructor() {
        super();
        this.state = {
            showAddProjectModal: false,
            newProjectName: "",
            isOpenLightBox: false,
            projectIndex: 0,
            newProjectDescription: '',
            showProjectPhotoIndex: 0
        };
        this.saveProject = this.saveProject.bind(this);
        this.showModal = this.showModal.bind(this);
        this.deleteProject = this.deleteProject.bind(this);
    }
    componentWillMount() {
        this.props.fetchProjects();
    }
    saveProject() {
        let files = this.refs.addProjectFileInput.files,
            filesUrl = [],
            ref = this;
        new Promise((resolve, reject) => {
            for (let i = 0; i < files.length; i++) {
                storageRef.ref(`/projects/${files[i].name}`).put(files[i]).then(data => {
                    console.log(i);
                    filesUrl.push(data.metadata.downloadURLs[0]);
                    if (filesUrl.length===files.length) {
                        resolve();
                    }
                });
            }
        })
            .then(_ => {
                $.ajax({
                    type: "POST",
                    url: "https://us-central1-portfolio-336c8.cloudfunctions.net/addProject",
                    data: { name: this.state.newProjectName, images: filesUrl, description: this.state.newProjectDescription, dateAndTime: (new Date().toString()) },
                    crossDomain: true,
                    success: function (data, status) {
                        ref.setState({ showAddProjectModal: false });
                        ref.props.fetchProjects();
                    },
                    beforeSend: function (xhr) { xhr.setRequestHeader("Access-Control-Allow-Origin", "*") }
                });
            });
    }
    showModal(res) {
        this.setState({ showAddProjectModal: res });
    }
    deleteProject(id) {
        fetch(`https://us-central1-portfolio-336c8.cloudfunctions.net/deleteProject?projectId=${id}`).then(res => {
            this.props.fetchProjects();
        });
    }
    render() {
        return (
            <Container style={styles.mainContainer}>
                <Row>
                    <Col xs={10} sm={10} md={11}>
                        <h1 style={styles.mainHeading}>All Projects</h1>
                    </Col>
                    <Col xs={2} sm={2} md={1}>
                        <a href="JavaScript:void(0)" style={styles.addProjectIcon} onClick={_ => { this.showModal(true); }}>
                            <i className="fas fa-plus" style={{ marginTop: 40 }}></i>
                        </a>
                    </Col>
                </Row>
                <Modal
                    bsSize="sm"
                    aria-labelledby="contained-modal-title-sm"
                    show={this.state.showAddProjectModal}
                    onHide={_ => { this.showModal(false); }}
                    style={styles.addProjectModal}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-sm">Add Project</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form action="JavaScript:void(0)">
                            <TextField
                                floatingLabelText="Project Name"
                                onChange={e => { this.setState({ newProjectName: e.target.value }) }}
                                floatingLabelStyle={{ color: "#7f8c8d" }}
                                underlineFocusStyle={{ borderColor: "#7f8c8d" }}
                            />
                            <TextField
                                floatingLabelText="Project Description"
                                onChange={e => { this.setState({ newProjectDescription: e.target.value }) }}
                                floatingLabelStyle={{ color: "#7f8c8d" }}
                                underlineFocusStyle={{ borderColor: "#7f8c8d" }}
                            />
                            <FlatButton
                                label="Choose an Image"
                                labelPosition="before"
                                style={styles.uploadButton}
                                containerElement="label"
                            >
                                <input type="file" multiple style={styles.uploadInput} accept=".jpg, .png" ref="addProjectFileInput" />
                            </FlatButton>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <RaisedButton onClick={this.saveProject} label="Save" />
                        <RaisedButton backgroundColor="#c0392b" labelColor="#fff" onClick={_ => { this.setState({ showAddProjectModal: false }) }} label="Close" />
                    </Modal.Footer>
                </Modal>
                {
                    this.props.projects.projects.length ?
                        <div className="projects">
                            {this.props.projects.projects.map((project, i) => <Row style={styles.eachProjectDiv}>
                                <Col xs={11} sm={11} md={11}>
                                    <Col sm={3} md={2}>
                                        <img src={project.images[0]} style={styles.projectImage} onClick={_ => { this.setState({ isOpenLightBox: true, projectIndex: i, showProjectPhotoIndex: 0 }); }} alt="Project First IMG" />
                                        {project.images.length !== 1 && <p style={styles.viewMoreImages} onClick={_ => { this.setState({ isOpenLightBox: true, projectIndex: i, showProjectPhotoIndex: 1 }); }}>View {project.images.length - 1} more</p>}
                                    </Col>
                                    <Col sm={9} md={10}>
                                        <p style={window.innerWidth <= 750 ? styles.projectNameXS : styles.projectName}>{project.name}</p>
                                    </Col>
                                </Col>
                                <Col xs={1} sm={1} md={1}>
                                    <a href="JavaScript:void(0)" style={{ color: "gray" }} onClick={_ => { this.deleteProject(project.id); }}>
                                        <i className="fas fa-trash-alt project_trash" style={styles.projectControlIcon}></i>
                                    </a>
                                </Col>
                            </Row>)}
                        </div>
                        :
                        ""
                }
                {this.state.isOpenLightBox && <Lightbox
                    mainSrc={this.props.projects.projects[this.state.projectIndex].images[this.state.showProjectPhotoIndex]}
                    nextSrc={this.props.projects.projects[this.state.projectIndex].images[this.state.showProjectPhotoIndex + 1]}
                    prevSrc={this.props.projects.projects[this.state.projectIndex].images[this.state.showProjectPhotoIndex - 1]}
                    onCloseRequest={() => this.setState({ isOpenLightBox: false })}
                    onMovePrevRequest={() =>
                        this.setState({
                            showProjectPhotoIndex: (this.state.showProjectPhotoIndex - 1),
                        })
                    }
                    onMoveNextRequest={() =>
                        this.setState({
                            showProjectPhotoIndex: (this.state.showProjectPhotoIndex + 1) % this.props.projects.projects[this.state.projectIndex].images.length,
                        })
                    }
                />}
            </Container>
        );
    }
}

const styles = {
    mainContainer: {
        fontFamily: "Roboto Slab, Times New Roman,sans-serif"
    },
    mainHeading: {
        color: "#3c4858",
        fontSize: 43,
        fontWeight: 700
    },
    addProjectIcon: {
        cursor: "pointer",
        color: "gray"
    },
    eachProjectDiv: {
        marginTop: 20,
    },
    projectImage: {
        width: "100%",
        height: "100%",
        cursor: "pointer"
    },
    projectName: {
        fontWeight: 700,
        fontSize: 25,
        lineHeight: "80px"
    },
    projectNameXS: {
        fontWeight: 700,
        fontSize: 25,
        textAlign: "center"
    },
    viewMoreImages: {
        cursor: "pointer",
        textAlign: "center",
        color: "#7f8c8d",
        marginTop: 5
    },
    addProjectModal: {
        top: 80,
        right: 8
    },
    uploadButton: {
        verticalAlign: 'middle',
    },
    uploadInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
        marginTop: 10
    },
    projectControlIcon: {
        marginLeft: 15,
        fontSize: 16,
        textAlign: "right",
        transition: "all .40s ease",
        cursor: "pointer",
        position: "relative",
        top: "50%",
        transform: "translateY(250%)",
        right: 20
    }
};

export default connect(state => ({ projects: state.projects }), { fetchProjects })(AProjects);


// WEBPACK FOOTER //
// ./src/Components/AProjects.jsx